<template>
  <modal :value="show" persistent max-width="600">
    <template #title>You have an unsaved comment</template>
    <template #content>
      You have an unsaved comment. If you continue to vote on this
      reference without first saving it, it will be lost. Press
      <strong>Cancel</strong>
      below to go back and save your comment, or press
      <strong>Delete Comment</strong>
      to delete your unsaved comment and confirm your vote.
    </template>
    <template #actions>
      <action-button class="mr-2" @click="$emit('dismiss')">
        Cancel
      </action-button>
      <action-button
        color="error"
        @click="$emit('on-clear-comment-and-vote')"
      >
        Delete Comment
      </action-button>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/Common/Modal';
import ActionButton from '@/components/Common/ActionButton';

export default {
  name: 'UnsavedCommentModal',
  components: {
    Modal,
    ActionButton,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
